<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <mask
        id="rf-language-icon"
        width="24"
        height="24"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style="mask-type: alpha"
      >
        <path fill="inherit" stroke="none" d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#rf-language-icon)">
        <path
          fill="inherit"
          stroke="none"
          d="M8.31 20.75a9.6 9.6 0 0 1-5.06-5.06 9 9 0 0 1-.75-3.7q0-1.95.75-3.69A9.7 9.7 0 0 1 8.3 3.25a9 9 0 0 1 3.7-.75q1.95 0 3.69.75a9.7 9.7 0 0 1 5.05 5.05q.75 1.73.75 3.7 0 1.95-.75 3.69a9.6 9.6 0 0 1-5.05 5.06q-1.73.75-3.7.75-1.95 0-3.69-.75m3.69-.77q.77-1.02 1.29-2.05t.85-2.26H9.86q.35 1.27.86 2.3.51 1.04 1.28 2m-1.94-.28q-.57-.82-1.03-1.87-.45-1.05-.71-2.16h-3.4a8 8 0 0 0 2.13 2.62q1.35 1.06 3.01 1.41m3.88 0a7 7 0 0 0 3-1.4q1.34-1.07 2.13-2.63h-3.39a16 16 0 0 1-1.74 4.03M4.3 14.17h3.72a13 13 0 0 1-.14-3.25q.04-.54.14-1.1H4.3a8 8 0 0 0 0 4.35m5.22 0h4.96a13 13 0 0 0 0-4.34H9.52a13 13 0 0 0 0 4.34m6.46 0h3.72a8 8 0 0 0 0-4.34h-3.72a13 13 0 0 1 .14 3.25q-.04.54-.14 1.1m-.3-5.84h3.4a7.37 7.37 0 0 0-5.14-4.04q.57.88 1.02 1.9.45 1.04.72 2.14m-5.82 0h4.28q-.34-1.25-.88-2.31-.53-1.05-1.26-2a12 12 0 0 0-2.14 4.3m-4.93 0h3.39a14 14 0 0 1 1.74-4.04A7 7 0 0 0 7.03 5.7a8 8 0 0 0-2.1 2.62"
        />
      </g>
    </svg>
  </span>
</template>
